import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

export default async function _getTickerInfo([url, Ticker, subTab, first, offset, preview]) {
  const data = await fetchAPI(
    `
    query{
        getTickerInfo: getStockSummary(ticker: "${Ticker}") {
            ticker
            description
            industry
            short_description
            employees
            industry_group
            url
            ceo
            market_cap_category
            short_name_url
            long_name
            companyName: short_name
            realtime_stock_data {
                ticker
                price_type
                price
                ex_dividend
                split_ratio
                volume
                source
                record_date: rdt
                currency_code
            }
        }
        getTradingHours {
            location_code
            start_time
            end_time
            timezone
        }
    }
    `,
    { preview }
  )
  return data
}
